import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=39616317"
import script from "./whiteList.vue?vue&type=script&lang=js"
export * from "./whiteList.vue?vue&type=script&lang=js"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=39616317&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports